import { render, staticRenderFns } from "./importRoomArea.vue?vue&type=template&id=528332d1&scoped=true"
import script from "./importRoomArea.vue?vue&type=script&lang=js"
export * from "./importRoomArea.vue?vue&type=script&lang=js"
import style0 from "./importRoomArea.vue?vue&type=style&index=0&id=528332d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528332d1",
  null
  
)

export default component.exports